import { Component } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";

@Component({
  selector: "app-superlike-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatDividerModule],
  templateUrl: "./superlike-dialog.component.html",
  styleUrl: "./superlike-dialog.component.scss"
})
export class SuperLikeDialogComponent {
  readonly venmoLink = "https://venmo.com/";

  constructor(private readonly ref: MatDialogRef<SuperLikeDialogComponent>) {}

  close(): void {
    this.ref.close();
  }
}

